import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ade7e24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = { class: "app__header__title" }
const _hoisted_3 = { class: "app__title" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "icon-container" }
const _hoisted_6 = { class: "material-icons key-icon" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "content-section black__base__color" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons align-icon--bottom gray__base__color" }, " hotel ", -1))
const _hoisted_10 = { class: "title-sections" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons align-icon--bottom gray__base__color" }, " date_range ", -1))
const _hoisted_13 = { class: "title-sections" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = { class: "title-sections" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = { class: "content-section primary__color" }
const _hoisted_18 = { class: "title-sections" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = {
  key: 0,
  class: "pointer-link primary__dark__color maring-b-billing"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons icon-actions maring-icon-billing" }, "file_download", -1))
const _hoisted_22 = { class: "ma-0" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons icon-actions maring-icon-billing" }, "file_download", -1))
const _hoisted_25 = { class: "ma-0" }
const _hoisted_26 = {
  key: 0,
  class: "d-flex align-center"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons icon-actions pointer-link" }, "info_outline", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons icon-actions pointer-link" }, "info_outline", -1))
const _hoisted_29 = {
  key: 1,
  class: "d-flex align-center justify-center type-text maring-b-billing"
}
const _hoisted_30 = { class: "ma-0 maring-icon-billing" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons icon-actions pointer-link" }, "info_outline", -1))
const _hoisted_32 = {
  key: 0,
  class: "container-phone mt-20"
}
const _hoisted_33 = { class: "message-gp" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons icon glyphicon" }, "perm_phone_msg", -1))
const _hoisted_35 = { class: "demo-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_BillingFields = _resolveComponent("BillingFields")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      type: "flex",
      justify: "center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("bookings.title")), 1),
            _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("bookings.subtitle")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 24,
          class: "mt-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { shadow: "never" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, {
                  type: "flex",
                  justify: "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      span: 24,
                      class: "text--center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          class: "profile-image",
                          src: 
                  _ctx.participantData.profileImage
                    ? _ctx.participantData.profileImage
                    : 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
                ,
                          alt: "profile-image"
                        }, null, 8, _hoisted_4)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, {
                      class: "text--center mt-1 black__base__color current__text",
                      span: 24
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("bookings.currentBookings")), 1)
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bookings, (booking) => {
                      return (_openBlock(), _createBlock(_component_el_col, {
                        span: 24,
                        key: booking.id,
                        class: "rooms--max-width pa-1"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(booking.rooms, (room) => {
                            return (_openBlock(), _createBlock(_component_el_row, {
                              key: room.id,
                              justify: "center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, {
                                  xs: 8,
                                  sm: 8,
                                  md: 4,
                                  lg: 2,
                                  xl: 2,
                                  class: "center-flex mt-20"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_5, [
                                      _createElementVNode("i", _hoisted_6, _toDisplayString(booking.bookingStatus === "cancelled"
                          ? "event_busy"
                          : "vpn_key"), 1)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_col, {
                                  xs: 16,
                                  sm: 16,
                                  md: 8,
                                  lg: 4,
                                  xl: 4,
                                  class: "mt-20"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["title-sections", 
                      booking.bookingStatus
                        ? 'gray__base__color'
                        : 'primary__color'
                    ])
                                    }, _toDisplayString(_ctx.$t("bookings.bookingID")) + " " + _toDisplayString(booking.id), 3),
                                    _hoisted_7,
                                    _createElementVNode("span", _hoisted_8, _toDisplayString(room.name), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_col, {
                                  xs: 12,
                                  sm: 12,
                                  md: 6,
                                  lg: 4,
                                  xl: 4,
                                  class: "mt-20"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_9,
                                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("bookings.hotelName")), 1),
                                    _hoisted_11,
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["content-section", 
                      booking.bookingStatus
                        ? 'gray__base__color'
                        : 'primary__color'
                    ])
                                    }, _toDisplayString(booking.hotel.name), 3)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_col, {
                                  xs: 14,
                                  sm: 14,
                                  md: 6,
                                  lg: 4,
                                  xl: 4,
                                  class: "mt-20"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_12,
                                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("bookings.bookingDate")), 1),
                                    _hoisted_14,
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["content-section", 
                      booking.bookingStatus
                        ? 'gray__base__color'
                        : 'primary__color'
                    ])
                                    }, _toDisplayString(_ctx.filterDatesToLocalString(
                        booking.checkIn,
                        booking.checkOut
                      )), 3)
                                  ]),
                                  _: 2
                                }, 1024),
                                (booking.additionalComments)
                                  ? (_openBlock(), _createBlock(_component_el_col, {
                                      key: 0,
                                      xs: 24,
                                      sm: 24,
                                      md: 24,
                                      lg: 4,
                                      xl: 4,
                                      class: "mt-20"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("bookings.additionalComments")), 1),
                                        _hoisted_16,
                                        _createElementVNode("span", _hoisted_17, _toDisplayString(booking.additionalComments), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_el_col, {
                                  xs: 24,
                                  sm: 24,
                                  md: 24,
                                  lg: 4,
                                  xl: 4,
                                  class: "mt-20"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("bookings.status")), 1),
                                    _hoisted_19,
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["content-section", 
                      booking.bookingStatus === 'cancelled'
                        ? 'gray__base__color'
                        : 'primary__color'
                    ])
                                    }, _toDisplayString(_ctx.$t(`bookings.bookingStatus.${booking.bookingStatus}`)), 3)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_col, {
                                  xs: 24,
                                  sm: 24,
                                  md: 24,
                                  lg: 4,
                                  xl: 4,
                                  class: "mt-20 d-flex align-center justify-center"
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.billingIsGenerate(booking.id))
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          false
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                _hoisted_21,
                                                _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t("billing.downloadReceipt")), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", {
                                            onClick: ($event: any) => (_ctx.downloadInvoice(booking.id)),
                                            class: "d-flex align-center justify-center pointer-link primary__color maring-b-billing"
                                          }, [
                                            _hoisted_24,
                                            _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("billing.downloadInvoice")), 1)
                                          ], 8, _hoisted_23)
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          (!_ctx.billingIsGenerate(booking.id))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                                _createVNode(_component_el_button, {
                                                  class: "pointer-link",
                                                  disabled: !_ctx.billingExist(booking.id),
                                                  type: "danger",
                                                  onClick: ($event: any) => (_ctx.requestInvoice(booking.id))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t("billing.requestInvoice")), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["disabled", "onClick"]),
                                                (_ctx.getBillingError(booking.id))
                                                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                                      key: 0,
                                                      class: "box-item",
                                                      content: _ctx.getBillingError(booking.id),
                                                      placement: "top-start"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_27
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["content"]))
                                                  : _createCommentVNode("", true),
                                                (!_ctx.billingExist(booking.id))
                                                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                                      key: 1,
                                                      class: "box-item mr-1",
                                                      content: _ctx.$t('billing.billingProcessing'),
                                                      placement: "top-start"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_28
                                                      ]),
                                                      _: 1
                                                    }, 8, ["content"]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                                _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t("billing.invoiceRequested")), 1),
                                                _createVNode(_component_el_tooltip, {
                                                  class: "box-item",
                                                  content: _ctx.$t('billing.invoiceRequestedMore'),
                                                  placement: "top-start"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_31
                                                  ]),
                                                  _: 1
                                                }, 8, ["content"])
                                              ]))
                                        ], 64))
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_divider)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }),
                (_ctx.showGeneralPhone)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("contactUsMessage")), 1),
                      _createVNode(_component_el_row, { class: "text-box" }, {
                        default: _withCtx(() => [
                          _hoisted_34,
                          _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.generalPhone), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_BillingFields)
  ]))
}